import { render, staticRenderFns } from "./ChildCard.vue?vue&type=template&id=d6256736&scoped=true&"
import script from "./ChildCard.vue?vue&type=script&lang=js&"
export * from "./ChildCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6256736",
  null
  
)

export default component.exports